/** Only a known, stable allowance has a meaningful percentage. Purchased balances have no capacity. */
export function getCreditQuotaProgress(remaining: number | null | undefined, limit: number | null | undefined): {
  remaining: number;
  limit: number;
  progress: number;
  percent: number;
} | null {
  if (typeof remaining !== 'number' || !Number.isFinite(remaining) || remaining < 0
    || typeof limit !== 'number' || !Number.isFinite(limit) || limit <= 0) return null;
  const progress = Math.min(remaining / limit, 1);
  return { remaining, limit, progress, percent: progress * 100 };
}

export type CreditBalanceStatus = 'unknown' | 'available' | 'low' | 'insufficient' | 'exhausted';

/** Callers must scope the quote to the current account/project and exclude stale balances. */
export function getCreditBalanceStatus(balance: number | null | undefined, quote: number | null | undefined): CreditBalanceStatus {
  if (typeof balance !== 'number' || !Number.isFinite(balance)) return 'unknown';
  if (balance <= 0) return 'exhausted';
  if (typeof quote !== 'number' || !Number.isFinite(quote) || quote <= 0) return 'available';
  if (balance < quote) return 'insufficient';
  if (balance < Math.ceil(quote * 2)) return 'low';
  return 'available';
}
